import retryPolicy from "./retryPolicy";

const {
  retryWithBackoff: retryWithBackoffCore,
  isRetryableFailure,
  DEFAULT_MAX_ATTEMPTS,
} = retryPolicy;

/**
 * Whether a fetch-layer error is worth retrying for the given HTTP method.
 */
export function isRetryableFetchError(error, method = "GET") {
  if (!error) return false;

  const status = error.status;

  let networkCode = error.code;
  if (!networkCode && !status && error.name === "TypeError") {
    networkCode = "ERR_NETWORK";
  }

  return isRetryableFailure({ status, networkCode, method });
}

export async function retryWithBackoff(fn, options = {}) {
  return retryWithBackoffCore(fn, {
    isRetryableError: isRetryableFetchError,
    ...options,
  });
}

export { DEFAULT_MAX_ATTEMPTS };
